import React from "react";
import ceo from "../assets/ceo.png";

const CEO = () => {
  return (
    <div className="text-white bg-black">

      {/* HERO */}
      <section
        className="relative min-h-[90vh] flex items-center justify-center text-center"
        style={{
          backgroundImage: `url(${ceo})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/90 to-black"></div>

        <div className="relative z-10 px-6 max-w-3xl">
          <img
            src={ceo}
            alt="Farheen Ahmad"
            className="w-36 h-36 rounded-full mx-auto mb-6 border-4 border-purple-500 shadow-lg animate-float"
          />

          <h1 className="text-4xl md:text-6xl font-extrabold tracking-tight">
            Farheen Ahmad
          </h1>

          <p className="text-purple-400 mt-3 text-lg md:text-xl">
            CEO & Founder — TheLogicWaves
          </p>

          <p className="text-gray-300 mt-4 text-sm md:text-base max-w-xl mx-auto">
            Building impactful digital solutions that help brands grow, scale,
            and stand out in a competitive world.
          </p>
        </div>
      </section>

      {/* STORY */}
      <section className="py-24 px-6 max-w-4xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl font-bold mb-8">
          My Journey
        </h2>

        <p className="text-gray-300 leading-relaxed mb-6">
          My journey started with a vision — to build something meaningful,
          something that creates real impact. TheLogicWaves was born from
          passion, creativity, and a strong belief that technology can transform
          businesses.
        </p>

        <p className="text-gray-400 leading-relaxed mb-6">
          Over time, this vision evolved into a mission: to deliver high-quality,
          innovative, and scalable digital solutions that help brands grow,
          stand out, and succeed in a competitive world.
        </p>

        <p className="text-gray-400 leading-relaxed">
          At TheLogicWaves, we don’t just build projects — we build long-term
          value. Every design, every line of code, and every strategy reflects
          our commitment to excellence.
        </p>
      </section>

      {/* STATS / IMPACT */}
      <section className="py-20 bg-gradient-to-r from-purple-900/40 to-black text-center">
        <div className="max-w-5xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-8 px-6">
          <div>
            <h3 className="text-3xl font-bold text-purple-400">50+</h3>
            <p className="text-gray-300 text-sm mt-2">Projects Delivered</p>
          </div>
          <div>
            <h3 className="text-3xl font-bold text-purple-400">20+</h3>
            <p className="text-gray-300 text-sm mt-2">Happy Clients</p>
          </div>
          <div>
            <h3 className="text-3xl font-bold text-purple-400">3+</h3>
            <p className="text-gray-300 text-sm mt-2">Years Experience</p>
          </div>
          <div>
            <h3 className="text-3xl font-bold text-purple-400">100%</h3>
            <p className="text-gray-300 text-sm mt-2">Commitment</p>
          </div>
        </div>
      </section>

      {/* EXPERTISE */}
      <section className="py-24 px-6 max-w-5xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl font-bold mb-12">
          Expertise
        </h2>

        <div className="grid md:grid-cols-3 gap-8">
          <div className="bg-white/5 backdrop-blur-lg p-6 rounded-2xl border border-white/10 hover:scale-105 transition">
            <h3 className="text-xl font-semibold mb-3 text-purple-400">
              Web Development
            </h3>
            <p className="text-gray-400 text-sm">
              Modern, responsive, and scalable websites tailored for performance.
            </p>
          </div>

          <div className="bg-white/5 backdrop-blur-lg p-6 rounded-2xl border border-white/10 hover:scale-105 transition">
            <h3 className="text-xl font-semibold mb-3 text-purple-400">
              UI/UX Design
            </h3>
            <p className="text-gray-400 text-sm">
              Clean, user-focused designs that enhance user experience and engagement.
            </p>
          </div>

          <div className="bg-white/5 backdrop-blur-lg p-6 rounded-2xl border border-white/10 hover:scale-105 transition">
            <h3 className="text-xl font-semibold mb-3 text-purple-400">
              Digital Strategy
            </h3>
            <p className="text-gray-400 text-sm">
              Helping brands grow with smart, data-driven strategies.
            </p>
          </div>
        </div>
      </section>

      {/* QUOTE */}
      <section className="py-20 text-center bg-gradient-to-r from-purple-600 to-pink-600">
        <h2 className="text-2xl md:text-3xl font-bold max-w-3xl mx-auto">
          "Success comes from consistency, innovation, and the courage to think differently."
        </h2>
      </section>

      {/* CTA */}
      <section className="py-24 text-center px-6">
        <h2 className="text-3xl font-bold mb-6">
          Let’s Build Something Great Together
        </h2>

        <p className="text-gray-400 mb-8 max-w-xl mx-auto">
          Have an idea or project in mind? Let’s connect and turn your vision into reality.
        </p>

        <div className="flex flex-col md:flex-row gap-4 justify-center">
          <a
            href="/contact"
            className="px-6 py-3 bg-purple-600 hover:bg-purple-700 rounded-full font-semibold transition"
          >
            Contact Me
          </a>

          <a
            href="https://calendly.com/thelogicwaves/30min"
            target="_blank"
            rel="noreferrer"
            className="px-6 py-3 border border-purple-500 hover:bg-purple-500/20 rounded-full font-semibold transition"
          >
            Schedule a Meeting
          </a>
        </div>
      </section>

    </div>
  );
};

export default CEO;